import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { SleepSessionsRoutes } from "./Constants/routes";


const SleepSessions = () => {
  const match = useRouteMatch();
  return (
    <>
       <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {SleepSessionsRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/sleep-sessions" />
      </Switch> 
     
    </>
  );
};

export default SleepSessions;
